import Icon from "../../../../../Icon"

import styles from "./program-tabs.module.less"

export const ProgramTabs = ({ programs, active, onChange }) => {
  if (!programs.length) return null
  return (
    <div className={styles.programTabs}>
      {programs.map((p) => {
        const isActive = active === p.program
        return (
          <button
            key={p.program}
            type="button"
            className={`${styles.tab} ${isActive ? styles.tabActive : ""}`}
            onClick={() => onChange(p.program)}
            data-testid={`deflect-business-program-tab-${p.program}`}
          >
            {p?.brand && <Icon type={p.brand} className="icon" />}
            <span>{p.name}</span>
          </button>
        )
      })}
    </div>
  )
}
